/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from 'lodash';
import ControlDecorator from 'shared/ui/components/form-components/ControlDecorator.vue';
import MapFieldsModal from 'shared/ui/components/modals/MapFieldsModal.vue';
import { getFieldsForMapping } from 'shared/libs/utils/metadata';

const ALWAYS_ALLOWED_METADATA_KEYS = new Set(['fp_ext_id']);

const __vue_script__ = {
    name: 'MappedFields',

    components: {
        ControlDecorator,
    },

    props: {
        name: {
            type: String,
            default: 'fields_mapping',
        },

        value: {
            type: Object,
            default: () => ({}),
        },

        label: {
            type: String,
            default: null,
        },

        tip: {
            type: String,
            default: null,
        },

        entityType: {
            type: String,
            default: 'person',
        },

        eid: {
            type: String,
            required: true
        },

        apiFields: {
            type: Array,
            required: true
        },

        actionLabel: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            buttonLabel: this.actionLabel || this.$t('leads.settings.map_fields'),
            metadataFields: {},
            innerValue: {}
        };
    },

    computed: {
        uid() {
            return `${this.name}-${this._uid}`;
        }
    },

    async created() {
        const metadata = await this.$services.metadata.getMetadataForType(this.eid, this.entityType)
            .catch(err => {
                console.error('[MappedFields] could not get person metadata', err);
            });

        this.metadataFields = getFieldsForMapping(metadata, [...ALWAYS_ALLOWED_METADATA_KEYS]);

        if (isEmpty(this.value)) {
            this.innerValue = this.matchFields();
            this.$emit('input', this.innerValue);
        } else {
            this.innerValue = { ...this.value };
        }
    },

    methods: {
        openMapFieldsModal() {
            if (!this.apiFields.length) {
                console.warn('[MappedFields] missing api fields; mapping is disabled');
                return;
            }

            this.$modal.show(
                MapFieldsModal,
                {
                    mappings: this.innerValue,
                    metadataFields: this.metadataFields,
                    apiFields: this.apiFields,
                    save: mappings => {
                        this.innerValue = mappings;
                        this.$emit('input', mappings);
                    }
                },
                {
                    height: 'auto',
                    clickToClose: true,
                    adaptive: true,
                }
            );
        },

        matchFields() {
            const mapping = {};

            for (const apiField of this.apiFields) {
                if (this.metadataFields[apiField]) {
                    mapping[apiField] = apiField;
                }
                if (apiField === 'external_id') {
                    mapping[apiField] = 'fp_ext_id';
                }
            }

            return mapping;
        },

        getBadgeText(mdField, apiField) {
            const mdLabel = this.metadataFields[mdField]?.label || mdField;
            return `${apiField} = ${mdLabel} [${mdField}]`;
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "control-decorator",
    {
      staticClass: "mapped-fields",
      attrs: { uid: _vm.uid, label: _vm.label, tip: _vm.tip },
    },
    [
      _c(
        "div",
        { staticClass: "mapped-fields-list" },
        _vm._l(_vm.innerValue, function (mdField, apiField) {
          return _c(
            "span",
            { key: apiField, staticClass: "badge mapped-field-badge" },
            [_vm._v(_vm._s(_vm.getBadgeText(mdField, apiField)))]
          )
        }),
        0
      ),
      _c("div", { staticClass: "mapped-fields-action" }, [
        _c(
          "a",
          {
            staticClass: "has-action",
            class: { "is-disabled": !_vm.apiFields.length },
            attrs: {
              href: "#",
              role: "button",
              "aria-disabled": String(!_vm.apiFields.length),
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.openMapFieldsModal.apply(null, arguments)
              },
            },
          },
          [_vm._v(_vm._s(_vm.buttonLabel))]
        ),
      ]),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/MappedFields.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__